var intro = {
  content: [
    'When you want something,',
    'all the universe conspires',
    'in helping you to achieve it.',
    '<strong><i><small>Paulo Coelho</small></i></strong>',
    '',
    'Feed is that conspiracy:',
    'the conspiracy of trust.',
    '',
    'Trust is the single',
    'most important ingredient',
    'missing from digital relationships.',
    '',
    'Boston Consulting Group',
    'and the World Economic Forum',
    'forecast the digital economy',
    'to be worth between',
    '<strong>1.5 and 2.5 trillion dollars</strong>',
    '<strong>by 2016.</strong>',
    '',
    'The difference',
    'between those numbers',
    'is <a href="http://www3.weforum.org/docs/WEF_IT_RethinkingPersonalData_Report_2012.pdf " target="_blank">trust</a>.',
    '',
    'Feed is a digital mechanism of trust'
  ],
  desc: [
    "Feed is an intelligent property rights and payments platform, using intelligent software and digital security that goes well beyond 'military-grade' to give users true ownership of their data and IP.",
    "Feed facilitates trusted exchanges of users' progressively-perfecting data assets with businesses, researchers, and governments in a <b>trusted</b>, audited, and independently verifiable manner; on their own terms and conditions."
  ]
};

export default intro;
